import PropTypes from 'prop-types';
import '../../../styles/reports.css';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../../../../features/authentication/authSlice';
import { GenerateThresholdClass } from './generateThresholdClass';

const StudentsTable = ({
  data,
  persistData
}) => {
  const ferpaEnabled = useSelector(selectFerpaState);

  const generateTableRows= (classname, item)=>{
    return(
      <>
        <td className={`${classname} border`}>{item.preTest}%</td>
        {persistData.midTestID > 0 &&
        <>
          <td className={`${classname} border`}>{item.midTest}%</td>
        </>
        }
        {persistData.growth && persistData.midTestID > 0 &&
        <td className={`${classname} border ${GenerateThresholdClass(persistData.ThresholdPercent, item.preMidGrowth)}`}>{item.preMidGrowth}%</td>
        }
        <td className={`${classname} border`}>{item.postTest}%</td>

        {persistData.growth && persistData.midTestID > 0 &&
        <td className={`${classname} border ${GenerateThresholdClass(persistData.ThresholdPercent, item.midPostGrowth)}`}>{item.midPostGrowth}%</td>
        }

        {persistData.growth &&
        <td className={`${classname} border ${GenerateThresholdClass(persistData.ThresholdPercent, item.prePostGrowth)}`}>{item.prePostGrowth}%</td>
        }
      </>
    );
  };
  const generateTableHeaders= (classname)=>{
    return(
      <>
        <th rowSpan={2} className={`${classname} border rounded-0`}>Pre-Test</th>
        {persistData.midTestID > 0 &&
          <th rowSpan={2} className={`${classname} border`}>Mid-Test</th>
        }
        {persistData.growth && persistData.midTestID > 0 &&
        <th rowSpan={2} className={`${classname} border`}>Pre-Mid<br />Growth</th>
        }
        <th rowSpan={2} className={`${classname} border`}>Post-Test</th>
        {persistData.growth && persistData.midTestID > 0 &&
        <th rowSpan={2} className={`${classname} border`}>Mid-Post<br />Growth</th>
        }
        {persistData.growth &&
        <th rowSpan={2} className={`${classname} border`}>Pre-Post<br />Growth</th>
        }
      </>
    );
  };

  return (
    <div id='growthTable' className='mt-4 table-responsive growth-table-scroll-bar'>
      <table className='w-100 text-center growth-table'>
        <thead>
          <tr>
            <th colSpan={2} className='border'>Students</th>
            {persistData.studentID > 0 && 
              generateTableHeaders('bg-student-header')
            }
            {persistData.classID > 0 && 
              generateTableHeaders('bg-class-header')
            }
            {persistData.teacherID > 0 && 
              generateTableHeaders('bg-teacher-header')
            }
            {persistData.schoolID > 0 && 
              generateTableHeaders('bg-school-header')
            }
            {persistData.districtID > 0 && 
              generateTableHeaders('bg-district-header')
            } 
          </tr>
          <tr>
            <th className='border rounded-0'>First Name</th>
            <th className='border'>Last Name</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item,index)=>{
            return (
              <React.Fragment key={index}>
                <tr>
                  <td className='border'>{ferpaEnabled ? item.firstName : 'name hidden'}</td>
                  <td className='border'>{ferpaEnabled ? item.lastName : 'name hidden'}</td>
                  {persistData.studentID > 0 && 
                    generateTableRows('bg-student-header',item.studentGrowth)
                  }
                  {persistData.classID > 0 && 
                    generateTableRows('bg-class-header',item.classGrowth)
                  }
                  {persistData.teacherID > 0 && 
                    generateTableRows('bg-teacher-percentage',item.teacherGrowth)
                  }
                  {persistData.schoolID > 0 && 
                    generateTableRows('bg-school-percentage',item.schoolGrowth)
                  }
                  {persistData.districtID > 0 && 
                    generateTableRows('bg-district-percentage',item.districtGrowth)
                  }             
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

StudentsTable.propTypes = {
  data: PropTypes.array,
  persistData: PropTypes.object
};
  
export default StudentsTable;